import React from 'react';
import { motion } from 'framer-motion';
export function WhyItMattersNow() {
  return <section className="border-b border-[#D4AF37]/12 bg-[#08070A]" data-id="element-1479" data-mp="1n4sc4fuqfs3k">
      <div className="mx-auto max-w-3xl px-5 py-20 text-center sm:px-8" data-id="element-1480" data-mp="1n2fz8h3u07xd">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.28
      }} data-id="element-1481" data-mp="20vfeqj3m624x">
          <p className="text-[10px] font-medium uppercase tracking-[0.32em] text-[#D4AF37]" data-id="element-1482" data-mp="195kg1vtv903l">
            Why now
          </p>
          <h2 className="mt-5 font-serif text-3xl leading-tight text-[#FDFBF7] sm:text-5xl" data-id="element-1483" data-mp="147ran50e0a4d">
            History that isn&rsquo;t felt is history that fades.
          </h2>
          <p className="mt-7 text-lg font-light leading-relaxed text-[#FDFBF7]/70" data-id="element-1484" data-mp="1d4t5wplscdtv">
            Each generation grows further from the language, the context and
            the people who lived this story. What we build now, in a form the
            next generation can actually feel, is what carries it forward, for
            preservation, for education and for a wider understanding of who
            the Sikh Kingdoms really were.
          </p>
          <p className="mt-8 font-serif text-2xl text-[#D4AF37]" data-id="element-1485" data-mp="3vgplhzw69773">
            This is more than a project. It is a legacy we can build together.
          </p>
        </motion.div>
      </div>
    </section>;
}